/**
 * @stripe/stripe-react-native bridge — WEB STUB.
 *
 * Vite picks this file (`.web.tsx`) before the sibling `nativeStripe.tsx`.
 * Every export is a no-op so the static import resolves cleanly without
 * dragging the @stripe/stripe-react-native package (which has React Native
 * peer deps Vite can't bundle) into the web bundle.  All call sites are
 * gated behind `Platform.OS !== 'web'` so the stubs never actually run
 * at runtime — they only need to exist to satisfy the static import.
 */
export const NativeStripeProvider: any = null;
export const usePaymentSheet: any = () => null;
export const retrieveSetupIntent: any = async () => ({ setupIntent: null });
